import { Typography } from "@mui/material";
import React from "react";

export const NoDisplayLive = () => {
  return (
    <div className="bg-black h-custom-live flex flex-col items-center justify-center text-center p-4">
      <div className="flex flex-col items-center">
        <svg
          //   className="bg-white"
          width="40%"
          height="auto"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M52.3248 12.4266C50.8087 11.9135 49.1659 11.9135 47.6498 12.4266L19.4165 21.9891C18.4969 22.2878 17.6847 22.8489 17.0798 23.6033C16.475 24.3576 16.1039 25.2724 16.0123 26.2349C14.6081 43.8433 17.0456 56.8641 22.8331 66.7016C28.4331 76.2224 37.3915 83.1432 49.9873 88.3016C62.5956 83.1432 71.5623 76.2224 77.1623 66.7016C82.954 56.8683 85.3915 43.8433 83.9873 26.2349C83.8957 25.2724 83.5246 24.3576 82.9198 23.6033C82.3149 22.8489 81.5027 22.2878 80.5831 21.9891L52.3248 12.4266ZM45.6456 6.50993C48.4611 5.55541 51.5125 5.55395 54.329 6.50576L82.5873 16.0683C84.663 16.7595 86.491 18.0432 87.8459 19.7609C89.2009 21.4786 90.0235 23.5553 90.2123 25.7349C91.6831 44.1099 89.2123 58.5516 82.5498 69.8724C75.8665 81.2266 65.2123 89.0308 51.1331 94.5766C50.3968 94.8668 49.5778 94.8668 48.8415 94.5766C34.7748 89.0308 24.1248 81.2266 17.4456 69.8724C10.7873 58.5516 8.31647 44.1058 9.78313 25.7349C9.97197 23.5553 10.7946 21.4786 12.1495 19.7609C13.5044 18.0432 15.3324 16.7595 17.4081 16.0683L45.6456 6.50993Z"
            fill="#19607E"
          />
        </svg>
        <Typography
          variant="h6"
          className="text-gray-300 font-semibold mt-4"
          sx={{
            fontSize: {
              xs: "1rem", // Ukuran untuk layar kecil
              sm: "1.25rem", // Ukuran untuk layar sedang
              md: "1.5rem", // Ukuran untuk layar besar
            },
          }}
        >
          Kamera Tidak Tersedia
        </Typography>
        <Typography
          variant="body2"
          className="text-gray-400 mt-2"
          sx={{
            fontSize: {
              xs: "0.875rem", // Responsif untuk teks kecil
              sm: "1rem",
              md: "1.125rem",
            },
          }}
        >
          Pastikan kamera telah terhubung dan diizinkan untuk digunakan oleh
          aplikasi
        </Typography>
      </div>
    </div>
  );
};
